import module from './module.js'
/* Components */
import './components/component.js'

export default module.name



// WEBPACK FOOTER //
// ./src/kendu/document/index.js